import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AccreditedByEntityPositionRequest,
  AccreditedByEntityPositionResponse,
  AccreditedByEntityPositionSummaryRequest,
  AccreditedByEntityPositionSummaryResponse,
  AccreditedByPositionRequest,
  AccreditedByPositionResponse,
  AccreditedByPositionSummaryRequest,
  AccreditedByPositionSummaryResponse,
  ActivitiesByPeriodSummaryRequest,
  ActivitiesByPeriodSummaryResponse,
  ActivitiesByStateDetailRequest,
  ActivitiesByStateDetailResponse,
  ActivitiesByStateRequest,
  ActivitiesByStateResponse,
  EntityAttendanceGapRequest,
  EntityAttendanceGapResponse,
  EntityAttendanceGapSummaryRequest,
  EntityAttendanceGapSummaryResponse,
  GuestPhotoRequest,
  GuestPhotoResponse,
  RecurrentGuestsByActivityPathRequest,
  RecurrentGuestsByActivityRequest,
  RecurrentGuestsByActivityResponse,
  ReportEventsRequest,
  ReportEventsResponse,
  ReportExportCreateRequest,
  ReportExportCreateResponse,
  ReportExportDownloadRequest,
  ReportExportDownloadResponse,
  ReportExportStatusRequest,
  ReportExportStatusResponse,
  ReportStatesResponse,
  ReportStatesRequest,
} from '../dto';

export abstract class FullReportRepository {
  abstract recurrentGuestsByActivityPath(request: RecurrentGuestsByActivityPathRequest): string;
  abstract createReportExport(
    request: ReportExportCreateRequest,
  ): Observable<ReportExportCreateResponse>;
  abstract getReportExportStatus(
    request: ReportExportStatusRequest,
  ): Observable<ReportExportStatusResponse>;
  abstract downloadReportExport(
    request: ReportExportDownloadRequest,
  ): Observable<HttpResponse<ReportExportDownloadResponse>>;
  abstract getActivitiesByState(
    request: ActivitiesByStateRequest,
  ): Observable<ActivitiesByStateResponse>;
  abstract getActivitiesByStateDetail(
    request: ActivitiesByStateDetailRequest,
  ): Observable<ActivitiesByStateDetailResponse>;
  abstract getActivitiesByPeriodSummary(
    request: ActivitiesByPeriodSummaryRequest,
  ): Observable<ActivitiesByPeriodSummaryResponse>;
  abstract getAccreditedByPositionSummary(
    request: AccreditedByPositionSummaryRequest,
  ): Observable<AccreditedByPositionSummaryResponse>;
  abstract getAccreditedByEntityPosition(
    request: AccreditedByEntityPositionRequest,
  ): Observable<AccreditedByEntityPositionResponse>;
  abstract getAccreditedByEntityPositionSummary(
    request: AccreditedByEntityPositionSummaryRequest,
  ): Observable<AccreditedByEntityPositionSummaryResponse>;
  abstract getEntityAttendanceGap(
    request: EntityAttendanceGapRequest,
  ): Observable<EntityAttendanceGapResponse>;
  abstract getEntityAttendanceGapSummary(
    request: EntityAttendanceGapSummaryRequest,
  ): Observable<EntityAttendanceGapSummaryResponse>;
  abstract getAccreditedByPosition(
    request: AccreditedByPositionRequest,
  ): Observable<AccreditedByPositionResponse>;
  abstract getRecurrentGuestsByActivity(
    request: RecurrentGuestsByActivityRequest,
  ): Observable<RecurrentGuestsByActivityResponse>;
  abstract getGuestPhoto(request: GuestPhotoRequest): Observable<GuestPhotoResponse>;
  abstract getStates(request: ReportStatesRequest): Observable<ReportStatesResponse>;
  abstract getEvents(request?: ReportEventsRequest): Observable<ReportEventsResponse>;
}
